import { Instagram, MessageCircle, MapPin } from "lucide-react";
import {
    ADDRESS,
    INSTAGRAM_HANDLE,
    INSTAGRAM_URL,
    PHONE_DISPLAY,
    PSYCHOLOGIST,
    WHATSAPP_URL,
    handleWhatsAppClick,
} from "../../lib/site";

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="bg-[#F5F4F2] border-t border-[#B7A6B0]/40 py-16">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-5">
                    <p className="font-display text-3xl text-[#2F2F2F]">{PSYCHOLOGIST.name}</p>
                    <p className="overline mt-3">{PSYCHOLOGIST.crp}</p>
                    <p className="mt-6 text-sm leading-relaxed text-[#2F2F2F]/70 max-w-sm">
                        Psicoterapia individual e de casal. Atendimento online e presencial em Brasília.
                    </p>
                </div>

                <div className="md:col-span-4 space-y-5">
                    <p className="overline text-[10px]">Contato</p>
                    <a
                        href={WHATSAPP_URL}
                        onClick={handleWhatsAppClick}
                        data-testid="footer-whatsapp"
                        className="flex items-center gap-3 text-sm text-[#2F2F2F] hover:text-[#9f1e1e] transition-colors"
                    >
                        <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
                        {PHONE_DISPLAY}
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-instagram"
                        className="flex items-center gap-3 text-sm text-[#2F2F2F] hover:text-[#9f1e1e] transition-colors"
                    >
                        <Instagram className="w-4 h-4" strokeWidth={1.5} />
                        {INSTAGRAM_HANDLE}
                    </a>
                    <div className="flex items-start gap-3 text-sm text-[#2F2F2F]/80">
                        <MapPin className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={1.5} />
                        <span>{ADDRESS}</span>
                    </div>
                </div>

                <div className="md:col-span-3">
                    <p className="overline text-[10px] mb-5">Navegação</p>
                    <ul className="space-y-3 text-sm">
                        {[
                            ["Sobre", "#sobre"],
                            ["Como ajuda", "#terapia"],
                            ["Terapia para casais", "#casais"],
                            ["Atendimento", "#atendimento"],
                            ["Processo", "#processo"],
                            ["Perguntas", "#faq"],
                        ].map(([label, href]) => (
                            <li key={href}>
                                <a href={href} className="text-[#2F2F2F]/75 hover:text-[#9f1e1e] transition-colors">
                                    {label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14 pt-8 border-t border-[#B7A6B0]/40 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                <p className="text-xs text-[#2F2F2F]/55">
                    © {new Date().getFullYear()} {PSYCHOLOGIST.name}. Todos os direitos reservados.
                </p>
                <p className="text-xs text-[#2F2F2F]/55">
                    Conteúdo informativo. Não substitui avaliação clínica individual.
                </p>
            </div>
        </footer>
    );
};
